import { AccordionDetails, type AccordionDetailsProps } from "@mui/material";

export const MUIAccordionDetails: React.FC<AccordionDetailsProps> = ({ children, ...rest }) => (
  <AccordionDetails data-testid="accordion-content" {...rest}>
    {children}
  </AccordionDetails>
);
